import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import Home from "./pages/home/Home"
import Api from "./services/Api";
import Login from "./pages/login/Login";
import Room from "./pages/room/Room";
import Logging from "./pages/logging/Logging";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/room/:id',
    element: <Room />
  },
  {
    path: '/logging',
    element: <Logging />
  }
])

const App = () => {
  const api = Api.getInstance();
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!api.apiToken) {
      console.log('No token')
      setLoading(false);
    } else {
      console.log('Getting start info')
      api.get('start_session', ['invalid_token']).then(response => {
        api.session = response.json
        api.loggedIn = true

        setLoading(false);
        setLoggedIn(true);
      }).catch(response => {
        if (response.isExpectedError) {
          setLoading(false);
        } else {
          alert('Fatal Error: Cannot get start info');
        }
      })
    }
    console.log('Checked logged in, loggedIn ' + loggedIn)
  }, [])

  const login = () => {
    setLoggedIn(true)
  }

  if (loading) {
    return (<div className="p-4">Loading...</div>)
  } else if (!loggedIn) {
    return <Login login={login}/>;
  }

  return <RouterProvider router={router}/>
}

export { App };